(function (angular) {
    "use strict";
    angular.module('mobilezuz').directive('spProductsList', [
        function () {
            return {
                restrict: 'EA',
                templateUrl: 'views/templates/single-product-content.html'
            };
        }]);
})(angular);